import { Box, styled } from '@mui/material';

export const MiddlePanel = styled(Box)({
  display: 'flex',
  gap: '8px',
  alignItems: 'center',
  marginLeft: '8px',
});
